import { render } from "./SlimSummary.vue?vue&type=template&id=216f5e96"
import script from "./SlimSummary.vue?vue&type=script&lang=js"
export * from "./SlimSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__